module.exports = __webpack_public_path__ + "static/Face-Aidan.fa2dfe0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Aidan.jpg
// module id = 486
// module chunks = 144251824217401